import { render, staticRenderFns } from "./calendarioAsistencia.vue?vue&type=template&id=08263683&scoped=true"
import script from "./calendarioAsistencia.vue?vue&type=script&lang=js"
export * from "./calendarioAsistencia.vue?vue&type=script&lang=js"
import style0 from "./calendarioAsistencia.vue?vue&type=style&index=0&id=08263683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08263683",
  null
  
)

export default component.exports